/* eslint-disable react/prop-types */
import React from 'react';
import classNames from 'classnames';
import { Icon } from '@fiverr-private/fit';
import { r_chevron_down } from '@fiverr-private/fit/icons';

import './index.scss';

const SelectChevron = ({ innerProps, selectProps }) => (
    <div className={classNames('orca-select-chevron', { 'is-open': selectProps.menuIsOpen })} {...innerProps}>
        <Icon size={12}>{r_chevron_down}</Icon>
    </div>
);

export default SelectChevron;
